<div class="d-flex w-100">
  <div class="col-12 col-md-8 col-lg-7 left-container">
    <h3 class="m-0">{{ "Login" | translate }}</h3>
    <p>{{ "Welcome Back" | translate }}</p>
    <label>{{ "Email" | translate }}</label>
    <div class="input-container mt-1">
      <i class="bi bi-envelope left-icon"></i>
      <input [(ngModel)]="email" type="text" placeholder="{{ 'Enter your email' | translate }}" />
    </div>
    <div class="mt-4">
      <label>{{ "Password" | translate }}</label>
      <div class="input-container mt-1">
        <i class="bi bi-lock left-icon"></i>

        <input
          type="{{ showPassword ? 'text' : 'password' }}"
          placeholder="{{ 'Enter your password' | translate }}"
          [(ngModel)]="password"
        />

        <i
          class=" eye-icon {{ showPassword ? 'bi-eye-slash' : 'bi bi-eye ' }}"
          (click)="toggleShowPassword()"
        ></i>
      </div>
    </div>

    <div class="bold-text mt-4 forget" routerLink="/forget-password">
      {{ "Forget my password?" | translate }}
    </div>

    <button (click)="loginAsUser()" class="w-100 gradient-button">{{ "Login" | translate }}</button>

    <div class="or-divider mt-4">
      <div class="line"></div>
      <label>{{ "Or" | translate }}</label>
      <div class="line"></div>
    </div>
    <div class="d-flex justify-content-between social mt-4">
      <button (click)="loginWithGoogle()">
        <img width="8%" src="../../../../assets/img/google.svg" />
        {{ "Signup with Google" | translate }}
      </button>
      <button (click)="loginWithLinkedIn()">
        <img width="8%" src="../../../../assets/img/linkedIn-auth.svg" />
        {{ "Signup with LinkedIn" | translate }}
      </button>
    </div>
    <div class="text-center mt-4">
      {{ "Create an account?" | translate }}
      <span class="bold-text" routerLink="/sign-up">{{
        "Signup" | translate
      }}</span>
    </div>
  </div>

  <div class="d-none d-md-block col-md-4 col-lg-5 right-container">
    <img width="20%" src="../../../../assets/img/logo.png" />
    <br />
    <img width="80%" class="mt-3" src="../../../../assets/img/authGroup.svg" />
  </div>
</div>
